import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import classnames from 'classnames';
import clickOutside from 'react-click-outside';
import { map } from 'lodash/fp';
import { ReactComponent as Arrow } from 'svgs/leftarrow.svg';
import HoverButton from './HoverButton/index';
import styles from './locationFilter.module.css';

class LocationFilter extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedOption: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.toggleOptions = this.toggleOptions.bind(this);
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }
  state = {
    showOptions: false,
    selectedOption: this.props.selectedOption ?? this.props.options[0],
  };
  toggleOptions() {
    this.setState({ showOptions: !this.state.showOptions });
  }
  handleOptionClick(id) {
    this.setState({ selectedOption: id });
    this.props.onClick(id);
  }
  handleClickOutside = () => {
    this.setState({ showOptions: false });
  };
  render() {
    return (
      <CSSTransitionGroup
        component="div"
        className={classnames(styles.container, {
          [styles.shown]: this.state.showOptions,
        })}
        onClick={this.toggleOptions}
        transitionName={{
          enter: styles.enter,
          enterActive: styles.enterActive,
          leave: styles.leave,
          leaveActive: styles.leaveActive,
        }}
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        <div className={styles.currentContainer}>
          <div>{this.state.selectedOption.Name}</div>
          <Arrow className={styles.arrow} />
        </div>
        {this.state.showOptions ? (
          <div className={styles.options}>
            {map(
              option => (
                <HoverButton
                  key={option.UrlName}
                  onClick={() => this.handleOptionClick(option)}
                  label={option.Name}
                  styles={styles.option}
                  hoveredStyles={styles.optionHovered}
                />
              ),
              this.props.options,
            )}
          </div>
        ) : null}
      </CSSTransitionGroup>
    );
  }
}

export default clickOutside(LocationFilter);
// for testing
export { LocationFilter };
